import type { ExtraSessionsStats } from "@/Modules/Models/Domain/Sessions";

import { getExtraSessionsStats } from "@/Services/TherapyApi/Users";

import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import { camel } from "@/Utils/Camelize";
import { hasValue } from "@/Utils/Objects";

async function fetchExtraSessionsStatsActionHandler(): Promise<ExtraSessionsStats> {
  const resp = await getExtraSessionsStats().catch(() => null);

  if (!hasValue(resp) || isApiError(resp)) {
    return { freeSessions: 0 };
  }

  return camel(resp);
}

export default fetchExtraSessionsStatsActionHandler;
